import {createContext, useContext} from "react";

export const PricingContext = createContext({
  pricing: [],
  loading: false,
});

export const usePricingContext = () => {
  const {loading, pricing = []} = useContext(PricingContext);
  const baremetalClusterPricing = pricing.find((item) => item.id === "Baremetal-Cluster");
  const baremetalPricing = pricing.find((item) => item.id === "Baremetal");
  const cloudInstancePricing = pricing.find((item) => item.id === "Cloud-Instances");
  return {
    baremetalClusterPricing,
    baremetalPricing,
    cloudInstancePricing,
    loading,
    pricing,
  };
};
